<template>
  <b-container>

    <h3>Quel est votre niveau de jeu</h3>


  <b-form-group v-for="q in questions" :key="q.key" :label="$t(q.key+'.label')">

      <b-form-checkbox-group v-if="q.type=='checkbox'" stacked :id="q.key" :name="q.key" v-model="self[q.key]" @input="$v[q.key].$touch()" :class="{ error: $v[q.key].$error }">
          <b-form-checkbox  v-for="v in q.values" :key="v" :value="v" >{{$t(q.key+'.'+v)}}</b-form-checkbox>
      </b-form-checkbox-group>

      <b-form-radio-group v-if="q.type=='radio'" stacked :id="q.key" :name="q.key" v-model="self[q.key]" @input="$v[q.key].$touch()" :class="{ error: $v[q.key].$error }">
          <b-form-radio  v-for="v in q.values" :key="v" :value="v" >{{$t(q.key+'.'+v)}}</b-form-radio>
      </b-form-radio-group>

  </b-form-group>

    <b-form-group  class="action">

     <div class="float-left">   <b-button variant="outline-primary" to="/section1">&lt; Précédent</b-button></div>
  <div class="float-right"><b-button variant="outline-primary" to="/section3" :disabled="$v.$invalid">Suivant &gt;</b-button></div>
</b-form-group>
  </b-container>
</template>

<script>
  import { mapFields } from 'vuex-map-fields';
  import { required } from "vuelidate/lib/validators";
  export default {
    name: 'section2',
    data () {
    return {
      questions: [
        { key: "firstTime", values: ['never', 'weeks', 'months', 'years'], type: "radio" },
        { key: "objective", values: ['jackpot', 'yield', 'fun'], type: "radio" },
        { key: "technics", values: ['montantes', 'champs', 'combinaison', 'repartition', 'gap'], type: "checkbox" },
        { key: "budget", values: ['lt10', '10to20', '20to50', '50to100', 'gt100'], type: "radio" },

      ]
      }
    },
  validations: {
    firstTime: { required },
    objective: { required },
    technics: { required },
    budget: { required }
  },
    computed: {
    self() {
      return this;
    },
    // When using nested data structures, the string
    // after the last dot (e.g. `firstName`) is used
    // for defining the name of the computed property.
    ...mapFields([
      'answers.firstTime',
      'answers.objective',
      'answers.technics',
      'answers.budget',
    ]),

  }
  }
</script>

<style scoped>

</style>